import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { IIntegrationRuleRelationshipGroups } from "../../../../../../models/integration-rule-relationship-group";
import { memo, useMemo, useState } from "react";
import { IntegrationRuleRelationshipGroup } from "./IntegrationRuleRelationshipGroupForm/IntegrationRuleRelationshipGroup";

const INTEGRATION_RULE_RELATIONSHIP_GROUP_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleRelationshipGroup/";
const integrationRuleRelationshipGroupService =
  new MainApi<IIntegrationRuleRelationshipGroups>(
    INTEGRATION_RULE_RELATIONSHIP_GROUP_ROUTE,
  );

const translationPath =
  "page.4uBus.integrationRule.integrationRuleRelationshipGroup.";

export const IntegrationRuleRelationshipGroupPage = memo(
  ({ busAutomationCode }: { busAutomationCode: number | null }) => {
    const { id: busIntegrationRuleId } = useParams();

    const { t } = useTranslation();

    const [relationshipGroupForm, setRelationshipGroupForm] = useState(false);

    const [selectedId, setSelectedId] = useState<string>();

    const columns: GridColDef<IIntegrationRuleRelationshipGroups>[] = [
      {
        field: "_4uBusRelationshipGroup",
        headerName:
          t(translationPath + "u_bus_relationship_group") ||
          "4uBus Relationship Group",
        renderCell: (params) => {
          if (!params.value) return "-";
          return (
            <OverflowTooltip
              text={params.value.name}
              tooltip={params.value.name}
              textTransform="none"
              variant="body2"
            />
          );
        },
      },
      {
        field: "priority",
        headerName: t(translationPath + "priority") || "Priority",
        renderCell: (params) => {
          if (!params.value) return "-";
          return (
            <OverflowTooltip
              text={params.value.toString()}
              tooltip={params.value.toString()}
              textTransform="none"
              variant="body2"
            />
          );
        },
      },
    ];

    const handleAdd = () => {
      setRelationshipGroupForm(true);
    };

    const handleRowClick = (
      params: GridRowParams<IIntegrationRuleRelationshipGroups>,
    ) => {
      if (!params.row) return;
      setRelationshipGroupForm(true);
      setSelectedId(params.row.id);
    };

    const handleBack = () => {
      setSelectedId(undefined);
      setRelationshipGroupForm(false);
    };

    const params = useMemo(() => {
      return {
        _4uBusIntegrationRuleId: busIntegrationRuleId,
      };
    }, [busIntegrationRuleId]);

    return (
      <Box sx={{ height: 600, width: "100%" }}>
        {relationshipGroupForm && (
          <Box
            sx={(t) => ({
              p: 1,
              px: 10,
              height: "100%",
              overflow: "auto",
              backgroundColor: t.palette.background.default,
              borderRadius: 1,
            })}
          >
            <IntegrationRuleRelationshipGroup
              id={selectedId}
              busIntegrationRuleId={busIntegrationRuleId}
              busAutomationCode={busAutomationCode}
              onBackButton={handleBack}
            />
          </Box>
        )}
        {!relationshipGroupForm && (
          <Box height={600}>
            <Table<IIntegrationRuleRelationshipGroups>
              showDefaultMacroFilters={false}
              service={integrationRuleRelationshipGroupService}
              serviceProps={params}
              columns={columns}
              title={t(
                translationPath + "integration_rule_relationship_groups",
              )}
              searchInput
              onAdd={handleAdd}
              onRowClick={handleRowClick}
              searchInputPlaceHolder={t(translationPath + "search")}
              addButtonLabel={
                t(
                  translationPath + "add_integration_rule_relationship_group",
                ) || "Add Integration Rule Relationship Group"
              }
              confirmOptions={{
                title: t(translationPath + "confirm.title"),
                description: t(translationPath + "confirm.description"),
                confirmationButtonProps: {
                  variant: "contained",
                },
              }}
            />
          </Box>
        )}
      </Box>
    );
  },
);
